<template>
  <div>
    <ButtonBack class="mb_m"/>

    <label-auto-entry />
    <input-name />
    <input-place />
    <input-date />
    <input-start />
    <input-finish />
    <input-time-zone />
    <input-close-time />
    <input-content />
    <slot></slot>
  </div>
</template>

<script>
import ButtonBack from '@/components/ButtonBack'
import LabelAutoEntry from '@/components/Event/LabelAutoEntry'
import InputName from '@/components/Event/InputName'
import InputPlace from '@/components/Event/InputPlace'
import InputDate from '@/components/Event/InputDate'
import InputStart from '@/components/Event/InputStart'
import InputFinish from '@/components/Event/InputFinish'
import InputTimeZone from '@/components/Event/InputTimeZone'
import InputCloseTime from '@/components/Event/InputCloseTime'
import InputContent from '@/components/Event/InputContent'

export default {
  components: {
    ButtonBack,
    LabelAutoEntry,
    InputName,
    InputPlace,
    InputDate,
    InputStart,
    InputFinish,
    InputTimeZone,
    InputCloseTime,
    InputContent,
  }
}
</script>
